import React, { useState} from 'react';
import { useDropzone } from 'react-dropzone';

import { VscCloudUpload } from "react-icons/vsc";

import { S3PlanUploadHandler } from '../../../../helper/s3ClientHandler';
import { LoadingIndicator } from '../../../../components/loadingIndicator/loadingIndicator';

export const RefUploader = ({setLoading, loading,  uploadedFiles, onFilesUploaded, planPath}) => {

    const [uploading, setUploading] = useState(false);
    const [fileAlert, setFileAlert] = useState(null);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => handleDrop({uploadedFiles, acceptedFiles, planPath}),
    });

    const handleDrop = async ({uploadedFiles, acceptedFiles, planPath}) => {
        if (loading || uploading) return;
        setFileAlert(null);
        if (acceptedFiles.length === 0) return;
        setLoading(true);

        setUploading(true);

        try {
            const uploadData = {
                files: acceptedFiles,
                path: planPath,
            }
            const files = await S3PlanUploadHandler(uploadData);
            setUploading(false);
            setLoading(false);
            await onFilesUploaded({files});
        } catch (error) {
            console.error('Error while uploading: ', error);
            setUploading(false);
            setLoading(false);
            return [];
        }
    };

    return (
        <div>
            <div {...getRootProps()}  className={ "mt-2 group flex justify-center rounded-lg border-2  border-gray-500 px-6 hover:cursor-pointer hover:border-gray-900  border-dashed "}>
                <div className="text-center w-full self-center">
                    <div className="flex text-left pt-4 text-sm leading-6 text-gray-900">
                        <label
                            htmlFor="file-upload"
                            onClick={(e) => {e.stopPropagation();}}
                            className=" relative text-sm w-full text-center cursor-pointer rounded-md border-[0] font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-0 "
                        >
                            {uploading ? (
                                <div className='flex flex-col gap-6 justify-center items-center w-full h-full'>
                                    <LoadingIndicator/>
                                    <b>Ihre Daten werden hochgeladen</b>
                                    <span className="block font-normal">
                                        Übertragung läuft...
                                    </span>
                                </div>
                            ) : (
                                <div>
                                    <VscCloudUpload className="mx-auto h-12 w-12 mb-6 text-gray-900 group-hover:text-indigo-500" aria-hidden="true" />
                                    <span className="block group-hover:text-indigo-500">
                                        Referenz Dateien
                                    </span>
                                    <span className="pl-1 block font-normal group-hover:text-indigo-500">
                                        Per Drag & Drop in diesen Bereich ziehen oder mit Klick in den Bereich hochladen
                                    </span>
                                    <p className="text-xs mt-6 leading-5 text-gray-600 group-hover:text-indigo-500">
                                        Referenzdaten bis zu 10MB
                                    </p>
                                    <span className="pt-1 block font-semibold text-red h-6">
                                        {fileAlert ? fileAlert : ''}
                                    </span>
                                </div>
                            )}
                            <input {...getInputProps()} id="file-upload" name="file-upload" type="file" className="sr-only" />
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};
